var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[_c('b-row',{staticClass:"h-100"},[_c('b-col',{attrs:{"lg":"12"}},[_c('h5',{staticClass:"my-3"},[_c('strong',[_vm._v("ข้อมูลข้อสอบ")])]),_c('h6',[_vm._v(_vm._s(_vm.result.title))]),_c('h6',[_vm._v(" "+_vm._s(_vm.result.shortDescription)+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }